import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(VAutocomplete, {
    attrs: {
      label: _vm.$t("filtros.organization"),
      placeholder: _vm.$t("filtros.organization"),
      outlined: "",
      filled: _vm.view,
      dense: "",
      items: _vm.processd_list_domains,
      rules: _vm.rules,
      "item-value": "value",
      readonly: _vm.view,
      disabled: _vm.isDisabled,
      multiple: _vm.multiple,
    },
    on: { change: _vm.emitChange },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }